"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LANDING_URL = exports.ENV_NAME = exports.API_URL = exports.API_KEY = void 0;
exports.loadEnv = loadEnv;
function loadBrowser() {
  if (typeof window !== 'undefined') {
    return window.__ENV__;
  }
}
function loadNode() {
  if (typeof process !== 'undefined') {
    return process.env;
  }
}
function loadEnv() {
  return loadBrowser() || loadNode() || {};
}
var _loadEnv = loadEnv(),
  API_URL = exports.API_URL = _loadEnv.API_URL,
  API_KEY = exports.API_KEY = _loadEnv.API_KEY,
  ENV_NAME = exports.ENV_NAME = _loadEnv.ENV_NAME,
  LANDING_URL = exports.LANDING_URL = _loadEnv.LANDING_URL;